// extracted by mini-css-extract-plugin
export default {"icon":"PendingAdvancementIcon__icon___J8OWH","approved":"PendingAdvancementIcon__approved___k9sDR"};